// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------  footer  ----------------------------------------- */
.footer-bg {
  background-color: #C2C8FF;
  color: #000;
}
.footer-text {
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  width: 80%;
  font-family: "Manrope", sans-serif;

}
.footer-text-right {
  font-weight: 700;
  font-size: 14px;
}
.footer-btn-app-link {
  color: white;
  border: 0.5px solid white;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  background-color: transparent;
  border-radius: 5px;
  min-width: 150px;
}
.credit-text {
  font-size: 12px;
  font-weight: 400;
  color: #f5f5f5;
}

.footer-link {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #000;
  text-decoration: none;
}
.footer-heading-links {
  color: #4733C9;
  font-size: 18px;
  font-weight: 700;
  font-family: "Manrope", sans-serif;
}

.input-footer {
  border-radius: 0px !important;
}
.subscribe-button {
  border-radius: 0px !important;
  background-color: #4733C9 !important;
  color: white !important;
}

.footer-credit-text-div {
  border-top: 0.7px solid #699d77;
}
.footer-credit-text {
  font-size: 15px;
  font-weight: bolder;
  color: #4733C9;
  font-family: "Manrope", sans-serif;

}

.activefooter {
  color: #4733C9;
}
/* -----------------------------  footer  ----------------------------------------- */
@media (max-width:580px) {
  .home-step-card{
    display: flex;
    flex-direction: row;
}
.footer-credit-text-div{
  align-items: center;
 display: flex;
 justify-content: center;
}
.footer-top-content{
  align-items: center;
}}`, "",{"version":3,"sources":["webpack://./src/components/FooterComponent/footer.css"],"names":[],"mappings":"AAAA,qFAAqF;AACrF;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kCAAkC;;AAEpC;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kCAAkC;;AAEpC;;AAEA;EACE,cAAc;AAChB;AACA,qFAAqF;AACrF;EACE;IACE,aAAa;IACb,mBAAmB;AACvB;AACA;EACE,mBAAmB;CACpB,aAAa;CACb,uBAAuB;AACxB;AACA;EACE,mBAAmB;AACrB,CAAC","sourcesContent":["/* -----------------------------  footer  ----------------------------------------- */\n.footer-bg {\n  background-color: #C2C8FF;\n  color: #000;\n}\n.footer-text {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n  width: 80%;\n  font-family: \"Manrope\", sans-serif;\n\n}\n.footer-text-right {\n  font-weight: 700;\n  font-size: 14px;\n}\n.footer-btn-app-link {\n  color: white;\n  border: 0.5px solid white;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n  background-color: transparent;\n  border-radius: 5px;\n  min-width: 150px;\n}\n.credit-text {\n  font-size: 12px;\n  font-weight: 400;\n  color: #f5f5f5;\n}\n\n.footer-link {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  color: #000;\n  text-decoration: none;\n}\n.footer-heading-links {\n  color: #4733C9;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: \"Manrope\", sans-serif;\n}\n\n.input-footer {\n  border-radius: 0px !important;\n}\n.subscribe-button {\n  border-radius: 0px !important;\n  background-color: #4733C9 !important;\n  color: white !important;\n}\n\n.footer-credit-text-div {\n  border-top: 0.7px solid #699d77;\n}\n.footer-credit-text {\n  font-size: 15px;\n  font-weight: bolder;\n  color: #4733C9;\n  font-family: \"Manrope\", sans-serif;\n\n}\n\n.activefooter {\n  color: #4733C9;\n}\n/* -----------------------------  footer  ----------------------------------------- */\n@media (max-width:580px) {\n  .home-step-card{\n    display: flex;\n    flex-direction: row;\n}\n.footer-credit-text-div{\n  align-items: center;\n display: flex;\n justify-content: center;\n}\n.footer-top-content{\n  align-items: center;\n}}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
